import React from "react"
import { graphql } from "gatsby";
import PropTypes from "prop-types";
import HtmlBlock from "../../../components/htmlBlock/htmlBlock";
import Image from "../../../components/image/image";

const AccordionContent = ({data, className}) => {
  const {content, image, imagePosition} = data || {};
  // console.log('content ',content);
  const position = imagePosition || 'Left';
  return (
    <div className={`accordionContent ${image ? 'accordionContent--'+position : ''} ${className || ''}`}>
      {
        (image && position === 'Left') && <Image data={image} />
      }
      {
        content && <HtmlBlock data={content.includes('<p>') ? content : `<p>${content}</p>`} />
      }
      {
        (image && position === 'Bottom') && <Image data={image} />
      }
    </div>
  )
}

AccordionContent.propTypes = {
  data : PropTypes.shape({
    content: PropTypes.string,
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    imagePosition: PropTypes.oneOf(['Left', 'Bottom'])
  })
};

export default AccordionContent;

export const AccordionFragment = graphql`
fragment AccordionFragment on DatoCmsComponentAccordion {
  heading
  content
  image{
    ...ContainerImageFragment
  }
  imagePosition
}`;



